<div class="w-100 mt-2" style="display: inline-block;" data-toggle="tooltip" data-placement="top"
  [title]="hsAddDataCommonFileService.getToolTipText(data)">
  <!-- TODO: Remove function call from template -->
  <hs-add-to-map [disabled]="!canAdd()" (add)="add()" [loading]="hsAddDataCommonFileService.loadingToLayman">
    <span
      *ngIf="hsAddDataCommonFileService.loadingToLayman && hsAddDataCommonFileService.asyncLoading">&emsp;{{'COMMON.uploading'
      |
      translateHs }}</span>
    <span
      *ngIf="hsAddDataCommonFileService.loadingToLayman && hsAddDataCommonFileService.readingData">&emsp;{{'COMMON.reading'
      |
      translateHs }}</span>
    <ngb-progressbar
      *ngIf="hsAddDataCommonFileService.loadingToLayman && (hsAddDataCommonFileService.asyncLoading || hsAddDataCommonFileService.readingData)"
      showValue="true" class="rounded-0 mb-1" type="secondary" [max]="1" [value]="hsLaymanService.totalProgress">
    </ngb-progressbar>
  </hs-add-to-map>
</div>
<div *ngIf="!hsAddDataCommonFileService.isAuthenticated()"
  class="alert alert-warning d-flex align-items-center mt-2 justify-content-between">
  <!-- TODO: Remove function call from template -->
  <p class="m-0"> {{'ADDLAYERS.SHP.loginRequired' | translateHs }}</p>
  <hs-layman-current-user></hs-layman-current-user>
</div>
